// extracted by mini-css-extract-plugin
export default {"Overlay":"Overlay_Overlay__QvtbA","content":"Overlay_content__XeuAr","withContent":"Overlay_withContent__Hr5GN"};